import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom'

function TopHeader() {
  // State to track if admin is logged in
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  
  // Check login status on component mount
  useEffect(() => {
    const loginStatus = sessionStorage.getItem('admin-login');
    setIsAdminLoggedIn(!!loginStatus);
  }, []);

  // WhatsApp number
  const phoneNumber = '+92320-0280281';
  const email = 'info@centrexmarineservices.com';
  
  // WhatsApp link with the phone number
  const whatsappLink = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}`;
  
  // Make sure the email link is properly formatted
  const emailLink = `mailto:${email}`;
  
  // Handle email click explicitly
  const handleEmailClick = (e) => {
    e.preventDefault();
    window.location.href = emailLink;
  };

  return (
    <div className='top-header'>
      <div className='container-fluid'>
        <div className='topheader-phoneno-email'>
          <Link href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-link">
            <FontAwesomeIcon icon={faWhatsapp} className="icon-spacing" />
            <span className="contact-text">{phoneNumber}</span>
          </Link>
          
          {/* Logo - centered in top header */}
          <div className="top-logo-container">
            <Link to="/" className="logo-link">
              <img src="/Logo/logo.jpg" alt="Company Logo" className="logo-img" />
            </Link>
          </div>
          
          <div className="d-flex align-items-center">
            <Link href={emailLink} onClick={handleEmailClick} className="email-link-topheader">
              <FontAwesomeIcon icon={faEnvelope} className="icon-spacing" />
              <span className="contact-text">{email}</span>
            </Link>
            
            {isAdminLoggedIn && (
              <Link to="/dashboard/create-blogs" className="admin-icon-btn ms-3">
                <FontAwesomeIcon icon={faUser} />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopHeader
